import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=b27d4df6&scoped=true&"
import script from "./Verification.vue?vue&type=script&lang=js&"
export * from "./Verification.vue?vue&type=script&lang=js&"
import style0 from "./Verification.vue?vue&type=style&index=0&id=b27d4df6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27d4df6",
  null
  
)

export default component.exports